<template>
  <div class="mt-2">
    <div class="row parent-div">
      <!-- Date Picker and PH Filter -->
      <div class="col-3 cal-div">
        <div class="card mb-3 ph-div" v-if="countries && countries.length">
          <div class="card-body p-3">
            <table
              v-if="tokenObj.UserType != userTypeStudent"
              class="table table-bordered custom-table mb-0 ph-table"
            >
              <thead class="thead-light">
                <tr>
                  <th class="d-flex align-items-center">
                    <input
                      type="checkbox"
                      id="chkAllPh"
                      class="mr-1"
                      v-model="showAllPh"
                      @change="showAllPhCheckChange"
                    />
                    <label
                      for="chkAllPh"
                      style="margin-top: 3px; margin-bottom: 0"
                    >
                      Show Public Holidays
                    </label>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div
                      v-for="item in countries"
                      :key="item.Id"
                      class="d-flex align-items-center"
                    >
                      <input
                        :id="`chk${item.Id}`"
                        type="checkbox"
                        class="mr-1"
                        v-model="item.Selected"
                        @change="countryCheckChange"
                      />
                      <label
                        :for="`chk${item.Id}`"
                        style="margin-top: 3px; margin-bottom: 0"
                      >
                        {{ item.Name }}
                      </label>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <template v-else>
              <div
                v-for="item in countries"
                :key="item.Id"
                class="d-flex align-items-center"
              >
                <input
                  :id="`chk${item.Id}`"
                  type="checkbox"
                  class="mr-1"
                  v-model="item.Selected"
                  @change="countryCheckChange"
                />
                <label
                  :for="`chk${item.Id}`"
                  style="
                    margin-top: 0;
                    margin-bottom: 0;
                    line-height: 1;
                    font-size: 13px;
                  "
                >
                  Show public holidays in my location
                </label>
              </div>
            </template>
          </div>
        </div>
        <v-date-picker
          :first-day-of-week="0"
          :model-config="modelConfig"
          :key="counter"
          v-model="selectedDate"
        />
      </div>
      <!-- /Date Picker and PH Filter -->

      <!-- Calendar -->
      <div class="schedule-div px-md-0 px-lg-0">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-8">
                <div class="navigation-div">
                  <button class="btn btn-light mr-3" @click="today">
                    Today
                  </button>
                  <button class="btn btn-light mr-3" @click="previous">
                    <i class="fas fa-less-than"></i>
                  </button>
                  <button class="btn btn-light mr-3" @click="next">
                    <i class="fas fa-greater-than"></i>
                  </button>
                  <label class="period-lbl" style="margin-bottom: 0 !important">
                    <h5 style="margin-bottom: 0 !important">
                      {{ displayedPeriod }}
                    </h5>
                  </label>
                </div>
              </div>
              <div class="col-4">
                <div class="navigation-div text-right">
                  <button
                    :class="
                      selectedView == 'Day'
                        ? 'selected btn btn-light mr-3'
                        : 'btn btn-light mr-3'
                    "
                    @click="changeView('Day')"
                  >
                    Day
                  </button>
                  <button
                    :class="
                      selectedView == 'Week'
                        ? 'selected btn btn-light mr-3'
                        : 'btn btn-light mr-3'
                    "
                    @click="changeView('Week')"
                  >
                    Week
                  </button>
                  <button
                    :class="
                      selectedView == 'Month'
                        ? 'selected btn btn-light'
                        : 'btn btn-light'
                    "
                    @click="changeView('Month')"
                  >
                    Month
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <component
                  :is="selectedView"
                  :selectedDate="selectedDate"
                  :selectedCountries="selectedCountries"
                  :instructorId="isInstructor ? tokenObj.Id : ''"
                  :schoolId="
                    tokenObj.UserType == userTypeMainAdmin
                      ? schoolId
                      : tokenObj.SchoolId
                  "
                  :subjectName="subjectName"
                  :subjectLevelName="subjectLevelName"
                  :duration="duration"
                  :frequency="frequency"
                  :locationId="locationId"
                  :availability="availability"
                  :startDate="startDate"
                  :endDate="endDate"
                  :startTimeHour="startTimeHour"
                  :startTimeMinute="startTimeMinute"
                  :startTimePart="startTimePart"
                  :endTimeHour="endTimeHour"
                  :endTimeMinute="endTimeMinute"
                  :endTimePart="endTimePart"
                  :key="counter"
                  :instructorName="instructorName"
                  @showPublicHoliday="showPublicHoliday"
                  @showClass="showClass"
                  @showMore="showMore"
                ></component>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Calendar -->
    </div>

    <!-- Public Holiday Modal -->
    <div class="modal custom-modal fade" id="phModal" role="dialog">
      <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header pb-0" style="border: 1px solid #dee2e6">
            <h5 class="modal-title">Public Holiday</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body px-3 pt-3 pb-0">
            <form>
              <div class="form-group">
                <label class="mb-0"><b>Event Name</b></label>
                <div>{{ eventName }}</div>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="form-group col-6 mb-0">
                    <label class="mb-0"><b>Date</b></label>
                    <div
                      v-html="formatDate(date)"
                      style="line-height: 17px"
                    ></div>
                  </div>
                  <div class="form-group col-6 mb-0">
                    <label class="mb-0"><b>Country</b></label>
                    <div>{{ country }}</div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- /Public Holiday Modal-->

    <!-- Event Modal -->
    <div class="modal custom-modal fade" id="classModal" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content" :style="`background-color:${color}`">
          <div
            class="modal-header pb-0"
            style="border-bottom: 1px solid darkgray"
          >
            <h5 class="modal-title">{{ eventName }} ({{ classDuration }})</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body px-3 pt-3 pb-0">
            <div class="form-group">
              <div class="row">
                <div class="form-group col-6 mb-0">
                  <label class="mb-0"><b>School</b></label>
                  <div>{{ school }}</div>
                </div>
                <div class="form-group col-6 mb-0">
                  <label class="mb-0"><b>Instructor(s)</b></label>
                  <div v-if="instructors && instructors.length">
                    <ul v-if="instructors.length > 1">
                      <li v-for="(item, i) in instructors" :key="i">
                        {{ item.Name }}
                        <span style="color: red" v-if="item.Status">
                          ({{ item.Status }})
                        </span>
                      </li>
                    </ul>
                    <span v-else>{{ instructors[0].Name }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="form-group col-6 mb-0">
                  <label class="mb-0"><b>Date</b></label>
                  <div>{{ date }}</div>
                </div>
                <div class="form-group col-6 mb-0">
                  <label class="mb-0"><b>Time</b></label>
                  <div>{{ time }}</div>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="location">
              <div class="row">
                <div class="form-group col-6 mb-0">
                  <label class="mb-0"><b>Location</b></label>
                  <div>{{ location }}</div>
                </div>
                <div
                  class="form-group col-6 mb-0"
                  v-if="location == 'School Address'"
                >
                  <label class="mb-0"><b>School Address</b></label>
                  <div
                    v-if="
                      locationSchoolAddresses && locationSchoolAddresses.length
                    "
                  >
                    <ul v-if="locationSchoolAddresses.length > 1">
                      <li v-for="item in locationSchoolAddresses" :key="item">
                        {{ item }}
                      </li>
                    </ul>
                    <span v-else>{{ locationSchoolAddresses[0] }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="form-group col-6 mb-0">
                  <label class="mb-0"><b>Class Fee</b></label>
                  <div>{{ fee }}</div>
                </div>
                <div class="form-group col-6 mb-0">
                  <label class="mb-0"><b>Availability</b></label>
                  <div>{{ classAvailability }}</div>
                </div>
              </div>
            </div>
            <div
              class="submit-section mt-0 mb-3"
              v-if="classAvailability == 'Yes'"
            >
              <button
                type="button"
                class="btn btn-sm btn-success submit-btn"
                @click="addClassBooking"
              >
                Add Class Booking
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Event Modal -->
  </div>
</template>

<script>
import API from "../../../http-common.js";
import config from "../../../config.js";
import Month from "./ClassListCalendarFormatMonth.vue";
import Week from "./ClassListCalendarFormatWeek.vue";
import Day from "./ClassListCalendarFormatDay.vue";
import $ from "jquery";
import axios from "axios";
export default {
  props: [
    "schoolId",
    "subjectName",
    "subjectLevelName",
    "duration",
    "frequency",
    "locationId",
    "availability",
    "startDate",
    "endDate",
    "startTimeHour",
    "startTimeMinute",
    "startTimePart",
    "endTimeHour",
    "endTimeMinute",
    "endTimePart",
    "instructorName",
  ],
  components: {
    Month,
    Week,
    Day,
  },
  data() {
    return {
      userTypeMainAdmin: config.USERTYPE_MAIN_ADMIN,
      userTypeSchoolAdmin: config.USERTYPE_SCHOOL_ADMIN,
      userTypeInstructor: config.USERTYPE_INSTRUCTOR,
      userTypeInstructorSchoolAdmin:
        config.USERTYPE_INSTRUCTOR_AND_SCHOOL_ADMIN,
      userTypeStudent: config.USERTYPE_STUDENT,
      selectedView: "Month",
      selectedDate: "",
      modelConfig: {
        type: "string",
        mask: "YYYY-MM-DD",
      },
      displayedPeriod: "",
      counter: 0,
      //for ph
      showAllPh: false,
      countries: [],
      selectedCountries: [],
      //for event and ph modal
      classId: "",
      eventName: "",
      classDuration: "",
      school: "",
      instructors: [],
      date: "",
      dateCal: "",
      time: "",
      location: "",
      locationSchoolAddresses: "",
      fee: "",
      classAvailability: "",
      color: "",
      country: "",
    };
  },

  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data;
    },
    todayDate() {
      let date = new Date();
      let day = date.getDate().toString().padStart(2, "0");
      let month = (date.getMonth() + 1).toString().padStart(2, "0");
      let year = date.getFullYear();
      return `${year}-${month}-${day}`;
    },
    isInstructor() {
      return (
        (this.tokenObj.UserType == this.userTypeInstructorSchoolAdmin ||
          this.tokenObj.UserType == this.userTypeInstructor) &&
        this.$route.path.includes("/instructor/") &&
        !this.$route.path.includes("/schooladmin/")
      );
    },
    isStudent() {
      return (
        this.tokenObj.UserType == this.userTypeStudent &&
        this.$route.path.includes("/student/")
      );
    },
  },

  watch: {
    selectedDate(val) {
      if (val) {
        this.getDisplayedPeriod();
        this.counter++;
      }
    },
    selectedView() {
      if (!this.selectedDate) this.selectedDate = this.todayDate;
      this.getDisplayedPeriod();
      this.counter++;
    },
    "$store.state.expandSidebar": function (val) {
      this.resize();
    },
  },

  methods: {
    formatDate(val) {
      if (!val) return "";
      if (val.includes(",")) return val.replace(",", ",<br/>");
    },
    changeView(view) {
      this.selectedView = view;
      this.$store.state.classFilter.selectedView = view;
    },
    today() {
      this.selectedDate = this.todayDate;
      this.$store.state.classFilter.selectedDate = this.todayDate;
    },
    previous() {
      let param = {
        Token: this.tokenObj.Token,
        Date: this.selectedDate,
        View: this.selectedView,
      };
      API.schedule
        .getPreviousDate(param)
        .then((response) => {
          if (response.data.success) {
            this.selectedDate = response.data.previousDate;
            this.$store.state.classFilter.selectedDate = this.selectedDate;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    next() {
      let param = {
        Token: this.tokenObj.Token,
        Date: this.selectedDate,
        View: this.selectedView,
      };
      API.schedule
        .getNextDate(param)
        .then((response) => {
          if (response.data.success) {
            this.selectedDate = response.data.nextDate;
            this.$store.state.classFilter.selectedDate = this.selectedDate;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getDisplayedPeriod() {
      let param = {
        Token: this.tokenObj.Token,
        Date: this.selectedDate,
        View: this.selectedView,
      };
      API.schedule
        .getDisplayedPeriod(param)
        .then((response) => {
          if (response.data.success) {
            this.displayedPeriod = response.data.displayedPeriod;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    showClass(payload) {
      if (payload) {
        this.classId = payload.classId;
        this.eventName = payload.eventName;
        this.classDuration = payload.duration;
        this.school = payload.school;
        this.instructors = payload.instructors;
        this.date = payload.date;
        this.dateCal = payload.dateCal;
        this.time = payload.time;
        this.location = payload.location;
        this.locationSchoolAddresses = payload.locationSchoolAddresses;
        this.fee = payload.fee;
        this.classAvailability = payload.availability;
        this.color = payload.availability == "Yes" ? "#E9FCE9" : "#DCDCDC";
        $("#classModal").modal("show");
      }
    },
    addClassBooking() {
      this.$store.state.class.classId = this.classId;
      this.$store.state.class.date = this.dateCal;
      this.$store.state.class.time = this.time;
      this.$store.state.class.instructorId =
        this.instructors && this.instructors.length == 1
          ? this.instructors[0].Id
          : "";
      this.$store.state.class.instructorName =
        this.instructors && this.instructors.length == 1
          ? this.instructors[0].Name
          : "";
      if (this.isInstructor) {
        this.$router.push({ name: "instructorClassBookingAdd" });
      } else if (this.isStudent) {
        this.$router.push({ name: "studentClassBookingForm" });
      } else {
        this.$router.push({
          name:
            this.tokenObj.UserType == this.userTypeMainAdmin
              ? "mainAdminClassBookingAdd"
              : "schoolAdminClassBookingAdd",
        });
      }
      $("#classModal").modal("hide");
    },
    showMore(date) {
      this.selectedView = "Day";
      this.selectedDate = date;
      this.counter++;
    },
    //for ph
    showAllPhCheckChange() {
      for (let item of this.countries) {
        item.Selected = this.showAllPh;
      }
      this.selectedCountries = this.showAllPh
        ? this.countries.map((c) => c.Id)
        : [];
      this.counter++;
    },
    countryCheckChange() {
      this.selectedCountries = this.countries
        .filter((c) => c.Selected == true)
        .map((c) => c.Id);
      this.showAllPh = this.selectedCountries.length == this.countries.length;
      this.counter++;
    },
    showPublicHoliday(payload) {
      if (payload) {
        this.eventName = payload.eventName;
        this.date = payload.date;
        this.country = payload.country;
        $("#phModal").modal("show");
      }
    },
    getInstructorCountries() {
      API.instructor
        .getInstructorCountries({
          Token: this.tokenObj.Token,
          Id: this.tokenObj.Id,
        })
        .then((response) => {
          if (response.data.success) {
            this.countries = response.data.data;
            for (let country of this.countries) {
              country.Selected = true;
            }
            this.selectedCountries = this.countries.map((c) => c.Id);
            this.showAllPh = true;
            this.counter++;
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getSchoolAddressCountries() {
      API.school
        .getSchoolAddressCountries({
          Token: this.tokenObj.Token,
          SchoolId:
            this.tokenObj.UserType == this.userTypeMainAdmin
              ? this.schoolId
              : this.tokenObj.SchoolId,
        })
        .then((response) => {
          if (response.data.success) {
            this.countries = response.data.data;
            for (let country of this.countries) {
              country.Selected = true;
            }
            this.selectedCountries = this.countries.map((c) => c.Id);
            this.showAllPh = true;
            this.counter++;
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getStudentLocationCountry() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          this.showPosition,
          this.showError,
          { timeout: 300000, maximumAge: 1800000 }
        );
      } else {
        console.error("Geolocation is not supported by this browser.");
      }
    },
    showPosition(position) {
      const { latitude, longitude } = position.coords;
      axios
        .get(
          `https://api.timezonedb.com/v2.1/get-time-zone?key=GS66VJW5BPIQ&format=json&by=position&lat=${latitude}&lng=${longitude}`
        )
        .then((response) => {
          if (response.status == 200) {
            let countryName = response.data.countryName;
            API.common
              .getCountries({ Token: this.tokenObj.Token })
              .then((response) => {
                if (response.data.success) {
                  let countries = response.data.data;
                  let country = countries.find((c) => c.Name == countryName);
                  if (country) {
                    this.countries.push({
                      Id: country.Id,
                      Name: country.Name,
                      Selected: true,
                    });
                    this.selectedCountries = this.countries.map((c) => c.Id);
                    this.showAllPh = true;
                    this.counter++;
                  }
                }
              })
              .catch((error) => {
                this.$swal(error.response.data.Message, { icon: "error" });
              });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
        });
    },
    showError(error) {
      switch (error.code) {
        case error.PERMISSION_DENIED:
          console.error("User denied the request for Geolocation.");
          break;
        case error.POSITION_UNAVAILABLE:
          console.error("Location information is unavailable.");
          break;
        case error.TIMEOUT:
          console.error("The request to get user location timed out.");
          break;
        case error.UNKNOWN_ERROR:
          console.error("An unknown error occurred.");
          break;
        default:
          console.error("An unknown error occurred.");
      }
    },
    //resize function
    resize() {
      window.setTimeout(() => {
        this.updateSize();
      }, 300);
    },
    updateSize() {
      let windowWidth = $(window).width();
      let scaleFactor = 1;
      let parentDivWidth = 1212.8;
      let sidebarWidth = $("div.sidebar").outerWidth();
      if (windowWidth > 1368) {
        $("div.parent-div").css({
          transform: `scale(${scaleFactor})`,
          width: "unset",
        });
      } else {
        let factor = 0.94;
        if (windowWidth > 991.98) {
          if (sidebarWidth < 61) {
            parentDivWidth = 1382.8;
            if (windowWidth >= 1351) {
              factor = 0.922;
            } else if (windowWidth >= 1165) {
              factor = 0.905;
            } else if (windowWidth >= 1009) {
              factor = 0.89;
            }
          } else {
            parentDivWidth = 1212.8;
            if (windowWidth >= 1351) {
              factor = 0.8;
            } else if (windowWidth >= 1165) {
              factor = 0.76;
            } else if (windowWidth >= 1009) {
              factor = 0.725;
            }
          }
        }
        scaleFactor = (windowWidth * factor) / parentDivWidth;
        $("div.parent-div").css({
          transform: `scale(${scaleFactor})`,
          width: parentDivWidth + "px",
        });
      }
      $("div.parent-div").css("transform-origin", `15px 0px`);
    },
  },

  created() {
    let selectedDate = this.$store.state.classFilter.selectedDate;
    this.selectedDate = selectedDate ? selectedDate : this.todayDate;
    let selectedView = this.$store.state.classFilter.selectedView;
    this.selectedView = selectedView ? selectedView : this.selectedView;
    //get countries for ph
    if (this.isInstructor) this.getInstructorCountries();
    else if (this.tokenObj.UserType == this.userTypeStudent)
      this.getStudentLocationCountry();
    else this.getSchoolAddressCountries();
  },

  mounted() {
    this.resize();
    window.addEventListener("resize", this.resize);
    //adjust word-spacing
    let userAgent = navigator.userAgent;
    let platform = navigator.userAgentData.platform || navigator.platform;
    let isWindow = /Win/i.test(platform);
    let isAndroid = /Android/i.test(userAgent);
    let isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
    let isMacos = /Mac/i.test(platform);
    if (isWindow || isAndroid || (isMacos && !isSafari)) {
      $(".ph-div").css("word-spacing", "-5px");
    }
  },
};
</script>

<style scoped>
.cal-div {
  max-width: fit-content;
  margin-bottom: 20px;
}
.ph-table {
  width: 100% !important;
}
.ph-div label,
.ph-div input[type="checkbox"] {
  cursor: pointer;
  text-align: left;
}
.ph-div .table thead th,
.ph-div .table tbody td {
  letter-spacing: 0px;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  padding-left: 10px !important;
  padding-right: 10px !important;
  white-space: unset;
  line-height: 17px;
}
.schedule-div {
  flex: 1;
}
.selected {
  background-color: #e2e6ea;
}
button.btn-danger {
  background: #f62d51 !important;
  border: 1px solid #f62d51 !important;
}
table {
  width: 100% !important;
}
ul {
  padding-left: 15px;
  line-height: 17px;
  margin-bottom: 0 !important;
}
@media only screen and (max-width: 431px) {
  .page-header {
    margin-bottom: 20px;
  }
  button.add-btn {
    font-size: 8px;
    max-width: fit-content !important;
    padding-top: 2px;
    padding-bottom: 1px;
    padding-left: 6px;
    padding-right: 6px;
  }
  h3.page-title {
    font-size: 14px;
    margin-bottom: 0 !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/SchoolUser/SchoolAdmin/ClassListCalendarFormat.vue